module.exports = __webpack_public_path__ + "img/1.de12f60e.png";